import { BsDatepickerConfig, BsDaterangepickerConfig, BsDaterangepickerInlineConfig } from 'ngx-bootstrap/datepicker';

export class DateConfig {
  public static DATE_FORMAT = 'MM/dd/yyyy';
  public static DATE_TIME_FORMAT = 'MM/dd/yyyy hh:mm a';
  public static DATEPICKER_INPUT_FORMAT = 'MM/DD/YYYY';
  public static BsDaterangepickerInlineConfig(): BsDaterangepickerInlineConfig {
    const config = DateConfig.BsDatepickerConfig();
    config.displayMonths = 1;
    return config;
  }

  public static BsDatepickerConfig(): BsDatepickerConfig {
    const config = new BsDatepickerConfig();
    config.showWeekNumbers = false;
    config.containerClass = 'theme-green gcc-datepicker-theme';
    config.dateInputFormat = DateConfig.DATEPICKER_INPUT_FORMAT;
    return config;
  }

  public static BsDaterangepickerConfig(): BsDaterangepickerConfig {
    const config = new BsDaterangepickerConfig();
    config.showWeekNumbers = false;
    config.containerClass = 'theme-green gcc-datepicker-theme';
    config.dateInputFormat = DateConfig.DATEPICKER_INPUT_FORMAT + '-' + DateConfig.DATEPICKER_INPUT_FORMAT;
    config.displayMonths = 2;
    return config;
  }
}
